import { gql } from '@apollo/client';

export const emailControllerNote = gql`
  mutation emailControllerNote($input: EmailRequest) {
    emailControllerNote(input: $input) {
      result
    }
  }
`;
